import { render } from "./ApprovalStatus.vue?vue&type=template&id=65ff44fd&scoped=true"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js"

import "./ApprovalStatus.vue?vue&type=style&index=0&id=65ff44fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ff44fd"]])

export default __exports__